module.exports = __webpack_public_path__ + "assets/9ab853efb5f76e891f4ac0023cac65a5.mp3";